import React, { FC } from "react";
import { DASHBOARD_CARDS_COUNT } from "../../../common/constants/common.constants";
import { dashobardItems } from "../../../common/constants/dashboard.constants";
import { generateSkeletonArrays } from "../../../utilities/helpers";
import SkeletonItem from "../../SkeletonItem/SkeletonItem";
import DashboardItem from "./DashboardItem/DashboardItem";
import "./DashboardOverview.scss";
import { dashboardStore } from "../../../contexts/dashboardStore";

const DashboardOverview: FC = () => {
  const { clubs, deposits, stakings } = dashboardStore();
  return (
    <>
      <div className="dashboard-overview">
        {clubs && deposits && stakings
          ? dashobardItems.map((item) => {
              return <DashboardItem dashboardItem={item} key={item.title} />;
            })
          : generateSkeletonArrays(DASHBOARD_CARDS_COUNT).map((item) => {
              return (
                <div className="dashboard-item" key={item}>
                  <SkeletonItem height={64} width={64} borderRadius={5} />
                  <SkeletonItem width={320} height={40} borderRadius={5} />
                  <SkeletonItem height={30} width={100} borderRadius={5} />
                </div>
              );
            })}
      </div>
    </>
  );
};

export default DashboardOverview;
